import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";

@Component({
  selector: "app-image-angle-from-center",
  templateUrl: "ImageAngleFromCenter.component.html",
})
export class ImageAngleFromCenterComponent implements OnInit {
  @Input() grafik: string;
  @Input() drehen: number;
  @Input() meinStyle = { "max-width": "150px" };
  @Input() hervorhebenStyle = "";
  @Output("owWinkelGeaendert") owWinkelGeaendert: EventEmitter<number>;
  private winkel: number;
  constructor() {
    this.owWinkelGeaendert = new EventEmitter();
  }

  ngOnInit() {
    this.winkel = 0;
  }

  holeWinkel(event: any) {
    const element = event.target;
    let x = event.offsetX ? event.offsetX : event.pageX - element.offsetLeft;
    let y = event.offsetY ? event.offsetY : event.pageY - element.offsetTop;
    x = x - element.width / 2;
    y = y - element.height / 2;
    const w = (Math.atan2(y, x) * 180) / Math.PI + this.drehen;
    // if (w<=180) this.winkel = w+this.drehen;
    // if (w>180)  this.winkel = 270 + w;
    if (w < 360 - this.drehen) {
      this.winkel = w;
    }
    if (w < 0) {
      this.winkel = 360 + w;
    }
    this.owWinkelGeaendert.emit(this.winkel);
  }

  hebeHervor(event: any) {
    const element = event.target;
    element.style.border = this.hervorhebenStyle;
  }

  machNormal(event: any) {
    const element = event.target;
    element.style.border = "";
  }
}
